import { render } from "./goods_question.vue?vue&type=template&id=7315a85a&scoped=true"
import script from "./goods_question.vue?vue&type=script&lang=js"
export * from "./goods_question.vue?vue&type=script&lang=js"

import "./goods_question.vue?vue&type=style&index=0&id=7315a85a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7315a85a"]])

export default __exports__